import { APP_ENV } from 'config';
import { useCallback, useEffect, useRef } from 'react';

export interface CustomerOSHook {
  init: () => void;
}

function useCustomerOS(): CustomerOSHook {
  const init = useCallback(() => {
    const cos = document.createElement('script');
    cos.src = 'https://cos.dashboard.kanda.co.uk/analytics-0.1.js';
    cos.id = 'customeros-metrics';
    cos.async = true;
    (document.body || document.head).appendChild(cos);
  }, []);

  const initRef = useRef<boolean>(false);
  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;
    if (APP_ENV === 'qa') return;
    init();
  }, [init]);

  return {
    init,
  };
}

export default useCustomerOS;

// <!-- CustomerOS code -->
//     <script id="customeros-metrics" type="text/javascript">
//       (function (c, u, s, t, o, m, e, r, O, S) {
//         var customerOS = document.createElement(s);
//         customerOS.src = u;
//         customerOS.async = true;
//         (document.body || document.head).appendChild(customerOS);
//       })(
//         window,
//         'https://cos.dashboard.kanda.co.uk/analytics-0.1.js',
//         'script',
//       );
//     </script>
//     <!-- End CustomerOS code -->
